function FixVersionIcon({ color = 'currentColor', height = '20', width = '20', opacity = '1' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M8.3335 19.1654V11.6654H0.833496L9.16683 3.33203H16.6668V10.832L8.3335 19.1654ZM13.3335 11.8112L15.0002 10.1445V4.9987H9.85433L8.18766 6.66536H13.3335V11.8112ZM10.0002 15.1445L11.6668 13.4779V8.33203H6.521L4.85433 9.9987H10.0002V15.1445Z"
        fill={color}
        fill-opacity={opacity}
      />
    </svg>
  );
}
export default FixVersionIcon;
